import React from 'react';
import Circle from './Circle';
import Squre from './Squre';
import Rounded from './Rounded';
import Text from './Text';
import propTypes from 'prop-types';

const Skeleton = (props) => {
  const { variant, width, height, className } = props;
  switch (variant) {
    case 'squre':
      return <Squre width={width} height={height} className={className} />;
    case 'rounded':
      return <Rounded width={width} height={height} className={className} />;
    case 'circle':
      return <Circle width={width} height={height} className={className} />;
    case 'text':
      return <Text width={width} height={height} className={className} />;
  }
};

Skeleton.propTypes = {
  variant: propTypes.oneOf(['text', 'squre', 'rounded', 'circle']),
};
Skeleton.defaultProps = {
  variant: 'text',
};

export default Skeleton;
